export default {
  bind: function (el, binding, vnode) {
    // Provided expression must evaluate to a function.
    if (typeof binding.value !== 'function') {
      var compName = vnode.context.name
      var warn = '[Vue-click-outside:] provided expression ' + binding.expression + ' is not a function, but has to be'
      if (compName) { warn += 'Found in component ' + compName }

      console.warn(warn)
    }
    // Define Handler and cache it on the element
    var bubble = binding.modifiers.bubble
    var handler = function (e) {
      if (bubble || (!el.contains(e.target) && el !== e.target)) {
        binding.value(e)
      }
    }

    el.__vueClickOutside__ = handler

    // add Event Listeners
    window.setTimeout(function () {
      document.addEventListener('click', handler)
    }, 300) // on ajoute un délai avant la détection de click
  },
  unbind: function (el, binding) {
    // Remove Event Listeners
    document.removeEventListener('click', el.__vueClickOutside__)
    el.__vueClickOutside__ = null
  }
}
